import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'dc-ui-logo',
  styleUrl: 'dc-ui-logo.scss',
  shadow: true,
})
export class DcUiLogo {
  @Prop() href?: string;
  @Prop() alt?: string;
  @Prop() label?: string;

  render() {
    const logo = 'https://dc-webtoolkit.azureedge.net/images/rexroth_logo_animated.gif';
    const img = (
      <img
        src={logo}
        alt={this.alt}
      />
    );

    return this.href ? (
      <a
        href={this.href}
        aria-label={this.label}>
        {img}
      </a>
    ) : (
      img
    );
  }
}
